import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { consumeAuthReturnPath } from "../routing/authReturnPath";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const returnPath = consumeAuthReturnPath(params.get("returnTo"));

    // Pattern A (common): backend redirects to /auth/callback?token=JWT
    const token = params.get("token");

    if (token) {
      localStorage.setItem("auth_token", token);
      return navigate(returnPath || "/dashboard", { replace: true });
    }

    // Pattern B: backend sets HttpOnly cookie session and redirects here with no token
    // In that case, just send them to an authenticated landing page.
    // If your app uses a "me" endpoint, you'd fetch it here, but we won't guess.
    navigate(returnPath || "/dashboard", { replace: true });
  }, [location.search, navigate]);

  return null;
}

